import {
	ChangeDetectionStrategy,
	Component,
	Input
} from '@angular/core';
import { CdkStep } from '@angular/cdk/stepper';

@Component({
	selector: 'go-step',
	templateUrl: './go-step.component.html',
	styleUrls: ['./go-step.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		{provide: CdkStep, useExisting: GoStepComponent }
	],
	standalone: false
})
export class GoStepComponent extends CdkStep {
	@Input()
	public hideIndicator = false;
}
